// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import CheckIcon from '@mui/icons-material/CheckCircle'
import { TableCell, TableRow } from '@mui/material'
import cn from 'classnames'
import noop from 'lodash/noop'
import omit from 'lodash/omit'
import React from 'react'
import { Mutation } from 'react-apollo'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import EditButton from '../../../common/iconButtons/EditButton'
import RestrictedView from '../../auth/RestrictedView'
import { i18n } from '../../index'
import { deleteContinuingChecklistItemMutation } from './checklistQueries'
import css from './checklistTable.css'

class ContinuingChecklistRow extends React.Component {
  render() {
    const { data, onEdit, onDelete } = this.props
    return (
      <TableRow>
        <TableCell className={cn(css.tableCell, css.descriptionCell)}>{data.description}</TableCell>
        <TableCell className={css.tableCell}>
          {data.type
            ? data.type.map((t) => i18n.t(`checkList.type.${t}`)).join(', ')
            : i18n.t('checkList.type.NotDefined')}
        </TableCell>

        {['Monthly', 'Weekly', 'Daily'].map((interval, i) => (
          <TableCell className={css.checkboxCell} padding='checkbox' key={i}>
            <CheckIcon className={data.interval === interval ? css.checkIconChecked : css.checkIcon} />
          </TableCell>
        ))}

        <TableCell className={css.actionsCell} align='right'>
          <RestrictedView requiredPermission='manage_ownStation'>
            <EditButton
              className={css.actionButton}
              onClick={() => (data.id ? onEdit(omit(data, ['__typename'])) : noop)}
            />
            <Mutation mutation={deleteContinuingChecklistItemMutation}>
              {(onMutate) => (
                <DeleteButton
                  className={css.actionButton}
                  onClick={() => (data.id ? onDelete(onMutate, data.id) : noop)}
                />
              )}
            </Mutation>
          </RestrictedView>
        </TableCell>
      </TableRow>
    )
  }
}

export default ContinuingChecklistRow
